angular.module('app').config(transportationRouting);

function transportationRouting($routeProvider) {
  $routeProvider
    .when('/transportation', {
      pageTitle: 'TRANSPORTATION',
      template: '<transportations-page></transportations-page>',
      menu: 'products',
      accessPermission: 'index_transportation_accountadmin',
      authReq: true,
    })
    .when('/transportation/new', {
      pageTitle: 'ADD_TRANSPORTATION',
      template: '<transportation-page></transportation-page>',
      breadcrumb: {
        label: 'TRANSPORTATION',
        parent: 'transportation',
        ajs: true,
      },
      menu: 'products',
      accessPermission: 'create_transportation_accountadmin',
      authReq: true,
    })
    .when('/transportation/:id', {
      params: {
        mode: null,
        activeTab: 0,
      },
      pageTitle: 'TRANSPORTATION_OVERVIEW',
      template: '<transportation-page></transportation-page>',
      breadcrumb: {
        label: 'TRANSPORTATION',
        parent: 'transportation',
        ajs: true,
      },
      menu: 'products',
      accessPermission: 'show_transportation_accountadmin',
      authReq: true,
    });
}

transportationRouting.$inject = ['$routeProvider'];
